module.exports = __webpack_public_path__ + "static/media/btn-submit.7e88f38c.png";